import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';
import { WingBlank,DatePicker, List  } from 'antd-mobile';
import {connect} from 'dva';

class MonthTj extends Component{
    constructor(props){
       
        super(props);
        this.state=({
            year:'',
            monthTj:[{AAF008: "1", AAF013: "0.00"},
                     {AAF008: "2", AAF013: "0.00"},
                     {AAF008: "3", AAF013: "0.00"},
                     {AAF008: "4", AAF013: "0.00"},
                     {AAF008: "5", AAF013: "0.00"},
                     {AAF008: "6", AAF013: "0.00"},
                     {AAF008: "7", AAF013: "0.00"},
                     {AAF008: "8", AAF013: "0.00"},
                     {AAF008: "9", AAF013: "0.00"},
                     {AAF008: "10", AAF013: "0.00"},
                     {AAF008: "11", AAF013: "0.00"},
                     {AAF008: "12", AAF013: "0.00"}]
        });
    }
    componentDidMount(){

        let myDate  = new Date();
        this.selectYear(myDate);
    }
    selectYear(year)
    {
        this.props.dispatch({type:"echart/getMonthTj",payload:{
        AAA001:localStorage.getItem("AAA001"),
        AAC002:localStorage.getItem("AAC002"),
        AAF008:this.formatDate(year)
        }}).then(()=>{

            this.setState({
                year,
                monthTj: this.props.monthTj

            });
        });
        
    }
    formatDate(date) {
        const dateStr = `${date.getFullYear()}`;
        return dateStr;
      }
    getOtion()
    {
        
        let option = {
            title:{
                text:'月用货量，单位元'
            },
            color: ['#3398DB'],
            tooltip : {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            yAxis : [
                {
                    type : 'category',
                    data : ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月','九月','十月','十一月','十二月'],
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            xAxis : [
                {
                    type : 'value'
                }
            ],
            series : [
                {
                    name:'用货量',
                    type:'bar',
                    barWidth: '90%',
                    label: {
                        normal: {
                            show: true,
                            position: 'inside'
                        }
                    },
                    data:[ this.state.monthTj[0].AAF013,
                           this.state.monthTj[1].AAF013,
                           this.state.monthTj[2].AAF013,
                           this.state.monthTj[3].AAF013,
                           this.state.monthTj[4].AAF013,
                           this.state.monthTj[5].AAF013,
                           this.state.monthTj[6].AAF013,
                           this.state.monthTj[7].AAF013,
                           this.state.monthTj[8].AAF013,
                           this.state.monthTj[9].AAF013,
                           this.state.monthTj[10].AAF013,
                           this.state.monthTj[11].AAF013,
                         ]
                }
            ]
        };
        return option;
    }
    getPosition = () =>{
        let height = window.screen.height-150;
        let width = window.screen.width;

        return {height: height+'px', 
                 width: width +'px'};
      };
    render(){
        return (
        <div >
        <WingBlank className="fullScreen">
            <DatePicker
            mode="year"
            title="选择年度"
            format={(date)=> this.formatDate(date)}
            extra="请先选择年度查看数据"
            value={this.state.year}
            onChange={year => this.selectYear(year)}
            >
            <List.Item arrow="horizontal">年度</List.Item>
            </DatePicker>
        
        </WingBlank >
        <br/>
        <br/>
        <br/>
        <WingBlank>
            <ReactEcharts option={this.getOtion()}style={{...this.getPosition()}}className='react_for_echarts' />
        </WingBlank>
        </div>
        );
    }
}
export default connect(state=>{
    return{
        monthTj:state.echart.monthTj
    }
})(MonthTj);